import { fetchWithAuth } from "../../../../api-client/api_client";

export interface ResolvedBlueprintIdentifier {
  kind: "INTEGRATION" | "BLUEPRINT" | "BLUEPRINT_VERSION";
  integration_id: string;
  integration_name: string;
  blueprint_id: string | null;
  blueprint_name: string | null;
  blueprint_version_id: string | null;
  blueprint_version_publish_state: string | null;
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Only a complete UUID is worth a lookup: a prefix cannot use the primary key index, and this
// keeps typing an Integration name from ever hitting the resolver.
export const isCompleteUUID = (value: string) => UUID_PATTERN.test(value.trim());

// Maps an Integration, Blueprint or BlueprintVersion ID to where it lives, which the editor URL
// needs and a pasted ID does not carry.
export const resolveBlueprintIdentifier = (identifier: string) =>
  new Promise<ResolvedBlueprintIdentifier | null>((resolve) =>
    fetchWithAuth({
      path: `/blueprints/resolve/${identifier.trim()}`,
      method: "GET",
      onResponse: (data?: ResolvedBlueprintIdentifier) => resolve(data ?? null),
      onError: () => resolve(null),
    })
  );
